/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import {
  type MultiplePermissionsAPIResult,
  type PermissionKey,
  useAnyPermissionAPI,
} from "@farmlands/permissions";
import { useSelector } from "react-redux";

import {
  selectCurrentAccountId,
  selectCurrentFarmerAccount,
  selectIdToken,
} from "../features/azure-b2c/storage";
import { selectRemoteConfig } from "../services/firebase/remote-config/remoteConfig.slice";

export type UseAnyPermissionResult = MultiplePermissionsAPIResult;

export const useAnyPermission = (keys: PermissionKey[]): UseAnyPermissionResult => {
  const remoteConfig = useSelector(selectRemoteConfig);
  const selectedAccountId = useSelector(selectCurrentAccountId) ?? "";
  const idToken = useSelector(selectIdToken);
  const selectedAccount = useSelector(selectCurrentFarmerAccount);
  const accountNumber = selectedAccount?.accountNumber ?? "";

  return useAnyPermissionAPI({
    permissions: keys,
    accountNumber,
    token: idToken ?? "",
    b2cAccountId: selectedAccountId,
    basePath: process.env.REACT_APP_PERMISSIONS_API_BASE_PATH ?? "",
    enabled: remoteConfig.permissionsChecksEnabled,
  });
};
